import { CreateServiceMapper } from "@catalogue/data/mappers/service/create-service.mapper";
import { Service } from "@catalogue/domain/models/service.model";
import { CreateServiceUseCase } from "@catalogue/domain/usecases/create-service.usecase";
import { ServiceFormValuesValidated } from "@catalogue/presentation/components/service/service-form.component";
import { Nullable } from "@core/domain/types/nullable.type";
import { LoadLayoutStore } from "@core/presentacion/component/feedback/load-layout/load-layout.store";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { BaseViewModel } from "@core/presentacion/view-model/base/base.viewmodel";
import { inject, injectable } from "inversify";

@injectable()
export class CreateServicePageViewModel extends BaseViewModel {
    constructor(
        @inject(CreateServiceUseCase)
        private readonly createServiceUseCase: CreateServiceUseCase,
        @inject(CreateServiceMapper)
        private readonly createServiceMapper: CreateServiceMapper,
    ) {
        super();
    }

    async createService(
        values: ServiceFormValuesValidated,
    ): Promise<Nullable<Service>> {
        LoadLayoutStore.start();

        const createdService = await this.createServiceUseCase.execute(
            this.createServiceMapper.mapFromForm(values),
        );

        LoadLayoutStore.finish();

        if (createdService) {
            ToastManagerStore.success();
        }

        return createdService as Nullable<Service>;
    }
}
